import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Nav from "./common/Nav";
import Footer from "./common/Footer";
import ServicesList from "./common/ServiceList";
import BannerForm from './common/Banner-Form';

import Bannerimg from "./img/banner1.jpg";
import Bannerimg2 from "./img/banner2.jpg";
import AboutImg from "./img/about-img.jpeg";
import AwardImg from "./img/awards.jpg"; 

import img1 from "./img/SANFRANCISCO.jpg";
import img2 from "./img/SACRAMENTO.jpg";
import img3 from "./img/SANJOSE.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faAward, faBuilding, faCartShopping, faCar, faCalendar, faLeftRight, faPeopleGroup } from '@fortawesome/free-solid-svg-icons';


const Main = () => {  
    const [currentImage, setCurrentImage] = useState(0); // Track the current image index
    const images = [Bannerimg, Bannerimg2]; // Array of images

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <div className="hero_area">
                <Nav />
                <section className="slider_section ">
                    <div className="slider_bg_box">
                        <img src={images[currentImage]} alt="" />
                    </div>
                    <div id="customCarousel1" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="container ">
                                    <div className="row">
                                        <div className="col-md-7 ">
                                            <div className="detail-box">
                                                <h1>Welcome to Golden State Movers </h1>
                                                <p>Golden State Movers is your trusted partner for seamless and reliable moving services across California. Whether it’s residential, commercial, or long-distance moves, our experienced team ensures a hassle-free experience with professional packing, careful handling, and timely delivery. Choose Golden State Movers for stress-free transitions and top-notch customer satisfaction.</p>
                                                <div className="btn-box">
                                                    <Link to="/contact" className="btn1"> Get A Quote </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="container ">
                                    <div className="row">
                                        <div className="col-md-7 ">
                                            <div className="detail-box">
                                                <h1>Welcome to Golden State Movers </h1>
                                                <p>Golden State Movers is your trusted partner for seamless and reliable moving services across California. Whether it’s residential, commercial, or long-distance moves, our experienced team ensures a hassle-free experience with professional packing, careful handling, and timely delivery. Choose Golden State Movers for stress-free transitions and top-notch customer satisfaction.</p>
                                                <div className="btn-box">
                                                    <Link to="/contact" className="btn1"> Get A Quote </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ol className="carousel-indicators">
                            <li data-target="#customCarousel1" data-slide-to="0" className="active"></li>
                            <li data-target="#customCarousel1" data-slide-to="1"></li>
                        </ol>
                    </div>
                    <div className='bannerForm bannerBig'>
                        <BannerForm />
                    </div>
                </section>
            </div>

            <div className='bannerForm bannerSmall'>
                <BannerForm />
            </div>

            <section className="about_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="img-box">
                                <img src={AboutImg} alt="" />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <br />
                            <div className="detail-box">
                                <div className="heading_container">
                                    <h2> About <span>Us</span> </h2>
                                </div>
                                <p>Golden State Movers is your trusted partner for seamless and reliable moving services across California. Whether you're relocating your home, office, or business, we ensure a stress-free experience tailored to meet your unique needs. Our team of experienced professionals is dedicated to handling every aspect of your move with care, efficiency, and attention to detail.</p>
                                <p>At Golden State Movers, we specialize in local and long-distance moves, offering comprehensive solutions that include packing, loading, transportation, and unpacking. We take pride in our commitment to customer satisfaction, ensuring your belongings are treated with the utmost care from start to finish.</p>
                                <p>With modern equipment, competitive pricing, and a passion for excellence, Golden State Movers makes the moving process simple and worry-free. Trust us to provide personalized service that turns a daunting task into a smooth transition. Choose Golden State Movers – where every move is a golden opportunity for a fresh start!</p>
                                <Link to="/about">Read More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="whychoose_section">
                <div className="container">
                    <div className="detail-box">
                        <div className="heading_container" style={{ alignItems: "center" }}>
                            <h2> Why <span> Choose Us</span> </h2>
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faDatabase} />
                                    <span>Affordable pricing with a flexible discount policy.</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faAward} />
                                    <span>Dedicated to excellence, always prioritizing our customers.</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faBuilding} />
                                    <span>Tailored moving services designed to fit your specific needs.</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faCartShopping} />
                                    <span>Guaranteed the best moving experience at the most competitive price.</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faCar} />
                                    <span>Punctual and reliable—we work tirelessly until you’re fully satisfied.</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faCalendar} />
                                    <span>Same-day moving services for your convenience.</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faLeftRight} />
                                    <span>We value your belongings as much as you do and handle them with utmost care.</span>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="whyContent">
                                    <FontAwesomeIcon icon={faPeopleGroup} />
                                    <span>Expert moving solutions, including packing, unpacking, loading, unloading, and transportation.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ServicesList />

            <section className="award_section" style={{ display: "none" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="heading_container">
                                <h2> Award for Golden Movers: <span>Excellence in Relocation Services</span> </h2>
                            </div>
                            <br />
                            <p>The Golden Movers Award celebrates excellence in the moving industry, honoring companies that deliver outstanding relocation experiences with unmatched professionalism and quality. Golden Movers exemplify trust and reliability, ensuring every move is smooth and stress-free. Their expertly trained crew, commitment to customer satisfaction, and full insurance coverage reflect their dedication to exceptional service.</p>
                            <p>With a coordinated fleet and strategic service areas, Golden Movers provide timely, efficient moves tailored to customer needs. Whether local or long-distance, they turn moving into a seamless journey. This award recognizes the industry's best for their pursuit of perfection and remarkable contributions.</p>
                        </div>
                        <div className="col-lg-6">
                            <img src={AwardImg} alt="Award Img" className="awardImg" />
                        </div>
                    </div>
                </div>
            </section>

            <section className='howItWorks'>
                <div className='container'>
                    {/* <div className="heading_container">
                        <h2 style={{ margin: "auto" }}>How It <span> Works</span></h2>
                    </div>
                    <br /> */}
                    <div className='row'>
                        <div className='col-lg-4'>
                            <div className='howWSec'>
                                <img src={img1} />
                                <br />
                                <a href="https://maps.app.goo.gl/qqWzpg8XJ3dTBzCW9"> Sanfrancisco</a>
                                <span className='lineBar'></span>
                                <Link to="/contact" className='hdng'>Get a Quote</Link>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='howWSec'>
                                <img src={img2} />
                                <br />
                                <a href="https://maps.app.goo.gl/HMTdGjWqXfNBSFeQ9?g_st=ic"> Sacramento</a>
                                <span className='lineBar'></span>
                                <Link to="/contact" className='hdng'>Get a Quote</Link>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='howWSec'>
                                <img src={img3} />
                                <br />
                                <a href="https://maps.app.goo.gl/GTt33ef8KGcvs7oD6?g_st=ic"> Sanjose</a>
                                <span className='lineBar'></span>
                                <Link to="/contact" className='hdng'>Get a Quote</Link> 
                            </div>
                        </div>
                    </div>
                </div>
            </section> 

            <section className="layout_padding">
                <div className="container">
                    <div className="heading_container text-center">
                        <h2> Need moving help? This is what our <span>packing and moving company</span> can do for you:</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-3"></div>
                        <div className="col-lg-9">
                            <br />
                            <ul className="notesLine">
                                <li>Free No Obligation Moving Estimate</li>
                                <li>Move Your Apartment, Condo, Home or Estate</li>
                                <li>Relocate Your Office, Warehouse or Large Corporation</li>
                                <li>Interstate or Intrastate Long Distance Moving Service</li>
                                <li>Full Packing & Unpacking Services</li>
                                {/* <li>Next Day Delivery of Moving Supplies & Boxes</li> */}
                                <li>On Site Moving Services</li>
                                <li>Load or Unload Your Rental Truck or POD</li>
                                <li>Junk Removal & E-Waste Services</li>
                                <li>Speciality Items Moving: Pianos, Safes, Pool Tables, Spas</li>
                                <li>White Glove Service & Deliveries</li>
                                {/* <li>Flexible Warehouse Storage Solutions</li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Main;